//import checkPermissions from './checkPermissions.js'
import Auth from './auth.js';
import Guest from './guest.js';



export default {
    Auth,
    Guest,
}